import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";

const Checkout = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const transactionId = searchParams.get("_ptxn");

    if (!transactionId) {
      setError("Missing transaction ID. Please return to the product page and try again.");
      return;
    }

    if (!window.Paddle) {
      setError("Payment system failed to load. Please refresh the page and try again.");
      return;
    }

    const token = import.meta.env.VITE_PADDLE_CLIENT_TOKEN;
    if (!token) {
      setError("Payment configuration error. Please contact support.");
      return;
    }

    try {
      const environment = import.meta.env.VITE_PADDLE_SANDBOX === "true" ? "sandbox" : "production";
      window.Paddle.Initialize({ token, environment });
      window.Paddle.Checkout.open({ transactionId });
    } catch (err) {
      setError("Failed to open checkout. Please refresh the page and try again.");
    }
  }, [searchParams]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <div className="text-center max-w-md">
          <AlertCircle className="h-12 w-12 text-destructive mx-auto mb-4" />
          <h1 className="text-xl font-semibold mb-2">Checkout Error</h1>
          <p className="text-muted-foreground mb-6">{error}</p>
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
          >
            Return to Homepage
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="flex flex-col items-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mb-4"></div>
        <p className="text-foreground font-medium">Processing your checkout...</p>
        <p className="text-muted-foreground text-sm mt-2">Powered by Upfixe</p>
      </div>
    </div>
  );
};

export default Checkout;
